import { Box, Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { Alert }  from '@material-ui/lab';
import { FullButton } from 'common/components/buttons/fullButton';
import moment from 'moment';
import { toastr } from 'react-redux-toastr';
import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import {
  COMPANY_SIGNED_IN_BACKGROUND_IMAGE,
  COMPANY_WEBSITE_SUBSCRIPTION_PLANS,
  SIGNED_IN_NAV_TEXT_COLOR,
} from '../../../../../../config/consts';
import ActivityAbstract from '../../components/ActivityAbstract';
import ItemCardMultiSelect from '../../components/ItemCard/multiSelect';
import ItemCardRadioSelect from '../../components/ItemCard/radioSelect';
import { subscribeProductsAction } from '../../shoppingActions';
import { getLastActionSubscriptionByCurrentUser } from '../../../homepage/userActionSubscriptions/userActionSubscriptionsActions';

let Subscription = function ({
  history,
  activity,
  activity: { products },
  handleSubmit,
  subscribeProductsAction,
  userSubscriptionAction,
  shopping: { btn_subscription_loading },
  getLastActionSubscriptionByCurrentUser,
}) {
  const [myProductId, setmyProductId] = useState(null);
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.only('xs'));
  const sm = useMediaQuery(theme.breakpoints.only('xs'));

  const checkLimitPerUser = useMemo(() => {
    if (parseInt(activity.limitPerUser) <= activity.userActions.length) {
      return false;
    } else return true;
  }, [activity.limitPerUser, activity.userActions.length]);

  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);

  useEffect(() => {
    getLastActionSubscriptionByCurrentUser(activity.id);
  }, [activity.id, getLastActionSubscriptionByCurrentUser]);

  const productsWithStock = useMemo(
    () =>
      products.filter((item) => item.single_product_orders.length < item.stock),
    [products]
  );

  async function onSubmit(values) {
    const products = [];
    for (let product in values) {
      const id = product.split('product-')[1];
      const quantity = values[product];
      products.push({ id, quantity });
    }
    subscribeProductsAction(products, activity.id, history);
  }

  const getProductId = (id) => {
    setmyProductId(id);
  };

  const onSubmitOnlyOneProduct = (values) => {
    const id = myProductId;
    const quantity = 1;
    if (!id) {
      toastr.error(
        'Produto não selecionado',
        'Por favor, selecione o produto para realizar a assinatura.'
      );
      return;
    }
    subscribeProductsAction([{ id, quantity }], activity.id, history);
  };

  const renderPaymentAlert = (userSubscriptionAction) => {
    if (userSubscriptionAction.paid) {
      return (
        <Alert severity="success">
          Tudo certo com sua assinatura!
          <div>
            Situação: <strong>Pago</strong>
          </div>
        </Alert>
      );
    }
    return (
      <Alert severity="warning">
        Já exite uma assinatura vigente para essa atividade.
        <div>
          Situação: <strong>Pagamento pendente.</strong>
        </div>
        <div style={{ float: 'right' }}>
          <strong
            style={{ cursor: 'pointer', color: '#ff9800', float: 'right' }}
            onClick={() => history.push('/homepage/cartao-assinatura')}
          >
            Adicionar cartão
          </strong>
        </div>
      </Alert>
    );
  }

  return (
    <Grid item container justifyContent="center" alignItems="center" xs={12}>
      <Form
        role="form"
        noValidate
        onSubmit={
          activity.only_one_product
            ? handleSubmit((v) => onSubmitOnlyOneProduct(v))
            : handleSubmit((v) => onSubmit(v))
        }
        style={{
          minWidth: '100%',
        }}
      >
        <Grid container justifyContent="center" alignItems="center" xs={12}>
          <Grid item container justifyContent="center" alignItems="center" xs={12}>
            <ActivityAbstract />
          </Grid>
          <Grid item container justifyContent="flex-start" xs={12} style={{ marginTop: -8, marginBottom: 24 }}>
            <Box x display="flex" flexDirection="column" width="100%">
              <Typography variant="body1">
                Recorrência assinatura: {
                  COMPANY_WEBSITE_SUBSCRIPTION_PLANS[activity.action_subscriptions[0].recurrence] ||
                  activity.action_subscriptions[0].recurrence
                }
              </Typography>
            </Box>
            <Typography variant="body1">
              Data fim recorrência: {moment(activity.participationEnd).format('DD/MM/YYYY')}
            </Typography>
            {userSubscriptionAction?.id && (
              <Box x display="flex" flexDirection="column" width="100%">
                <Typography variant="body1">
                  Situação do pagamento: { userSubscriptionAction?.paid ? 'Pago' : 'Pendente' }
                </Typography>
              </Box>
            )}
          </Grid>
          {activity.participationStart && activity.participationEnd ? (
            moment().isBetween(
              activity.participationStart,
              activity.participationEnd
            ) ? (
              checkLimitPerUser ? (
                productsWithStock.length > 0 ? (
                  productsWithStock.map((product) => (
                    <Field
                      key={product.id}
                      name={`product-${product.id}`}
                      data={product}
                      callBack={getProductId}
                      component={
                        activity.only_one_product
                          ? ItemCardRadioSelect
                          : ItemCardMultiSelect
                      }
                    />
                  ))
                ) : (
                  <Typography variant="body1" style={{ marginTop: 10 }}>
                    Produto indisponível para assinatura no momento.
                  </Typography>
                )
              ) : (
                  <Typography variant="body1" style={{ marginTop: 10 }}>
                  Olá, você assinou o produto dessa atividade!
                </Typography>
              )
            ) : (
              <>
                <Grid
                  item
                  container
                  justifyContent="center"
                  alignItems="center"
                  xs={12}
                  md={4}
                >
                  <Typography variant="body1" style={{ marginBottom: 32 }}>
                    Você pode verificar os produtos desta atividade entre os dias{' '}
                    {moment(activity.participationStart).format('DD/MM/YYYY')} às{' '}
                    {moment(activity.participationStart).format('HH:mm')} e{' '}
                    {moment(activity.participationEnd).format('DD/MM/YYYY')} às{' '}
                    {moment(activity.participationEnd).format('HH:mm')}.
                  </Typography>
                </Grid>
                <Grid
                  item
                  container
                  justifyContent="center"
                  alignItems="center"
                  xs={12}
                  md={4}
                >
                  <FullButton
                    classNameProp="py-3 px-4"
                    type="button"
                    onClick={() => history.push('/homepage')}
                    style={{
                      height: 52,
                      minWidth: '100%',
                    }}
                    isSecondary
                  >
                    Voltar
                  </FullButton>
                </Grid>
              </>
            )
          ) : (
            'Houve um problema com a data de publicação desta atividade.'
          )}
        </Grid>

        {checkLimitPerUser ? (
          productsWithStock.length > 0 ? (
            activity.participationStart && activity.participationEnd ? (
              moment().isBetween(
                activity.participationStart,
                activity.participationEnd
              ) ? (
                <>
                  <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    xs={12}
                    style={{
                      backgroundColor: COMPANY_SIGNED_IN_BACKGROUND_IMAGE,
                      border: `2px solid ${SIGNED_IN_NAV_TEXT_COLOR}`,
                      padding: '1.7rem 1.5rem',
                      borderRadius:'10px',
                    }}
                  >
                    <Grid
                      item
                      container
                      justifyContent={xs || sm ? 'center' : 'flex-start'}
                      alignItems="flex-start"
                      xs={12}
                      md={6}
                      style={{
                        marginBottom: xs || sm ? '.5rem' : null,
                        height: xs || sm ? '60px' : '',
                      }}
                    >
                      {userSubscriptionAction?.id
                        ? (
                          <div style={{ margin: '0px 16px' }}>
                            { renderPaymentAlert(userSubscriptionAction) }
                          </div>
                        )
                        : (
                          <Typography
                            gutterBottom={true}
                            component="p"
                            style={{ textAlign: 'start', maxWidth: '80%' }}
                            variant="body1"
                          >
                            Selecione o produto e confirme para completar a assinatura
                          </Typography>
                        )}
                    </Grid>
                    <Grid
                      item
                      container
                      justifyContent="center"
                      alignItems="center"
                      spacing={1}
                      xs={12}
                      md={6}
                      style={{
                        marginTop: xs || sm ? '.3rem' : null,
                      }}
                    >
                      <Grid
                        item
                        container
                        justifyContent="center"
                        alignItems="center"
                        xs={12}
                        md={4}
                      >
                        <FullButton
                          classNameProp="py-3 px-4"
                          type="button"
                          onClick={() => history.push('/homepage')}
                          style={{
                            height: 52,
                            minWidth: '100%',
                          }}
                          isSecondary
                        >
                          Voltar
                        </FullButton>
                      </Grid>
                      <Grid
                        item
                        container
                        justifyContent="center"
                        alignItems="center"
                        xs={12}
                        md={8}
                      >
                        <FullButton
                          disabled={userSubscriptionAction?.id || btn_subscription_loading}
                          fontSize="0.875rem"
                          classNameProp="py-3 px-4"
                          type="submit"
                        >
                          {btn_subscription_loading ? 'Processando assinatura' : 'Confirmar assinatura'}
                        </FullButton>
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              ) : null
            ) : null
          ) : null
        ) : null}
      </Form>
    </Grid>
  );
};

Subscription = reduxForm({
  form: 'shoppingForm',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(Subscription);

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    activity: state.activities.detail,
    formValues: getFormValues('shoppingForm')(state),
    shopping: state.shopping,
    userSubscriptionAction: state.userActionSubscriptions.content,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    subscribeProductsAction,
    getLastActionSubscriptionByCurrentUser,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Subscription);
